import { Button, Modal } from "antd";
import OTPInput from "../otpInput";

export const ModalOtp = ({
  onCancel,
  visible,
  otp,
  onChangeOtp,
  handleConfirm,
  errorMsg,
  loading,
  handleRequest,
  loadingRequest,
}) => (
  <Modal
    title="Codigo OTP enviado para o e-mail cadastrado. Informe o codigo para concluir o login."
    onCancel={onCancel}
    visible={visible}
    width="22%"
    close
    centered
    maskClosable={false}
    footer={[
      <>
        <Button onClick={handleRequest} loading={loadingRequest}>
          Solicitar Token
        </Button>

        <Button
          type="primary"
          onClick={handleConfirm}
          loading={loading}
          disabled={otp.length < 6}
        >
          Verificar código
        </Button>
      </>,
    ]}
  >
    <label style={{ fontWeight: "500" }}>Código OTP:</label>
    <OTPInput value={otp} onChange={onChangeOtp} />

    {errorMsg && <span style={{ color: "red" }}>{errorMsg}</span>}
  </Modal>
);
